export default "__VITE_ASSET__7031266f__"